import React from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';

import BillingInfo from './BillingInfo.jsx';
import DeleteEverything from './DeleteEverything.jsx';

import '../../styles/_global/Account.css';

class DisplayName extends React.Component {

    state = {
        value: this.props.initialValue
    };

    onChangeValue = ({currentTarget: { value }}) => {

        this.setState({ value });
    };

    onSubmit = e => {

        e.preventDefault();

        this.props.changeCover(true, () => {

            this.props.onSubmit(this.state.value, () => {

                this.props.changeCover(false, this.props.afterSubmit);
            });
        });
    };

    render() {

        return (
            <form onSubmit={this.onSubmit}>

                <div className="form-group">

                    <label htmlFor="display-name">Display Name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="display-name"
                        placeholder="Joan Doe"
                        value={this.state.value}
                        onChange={this.onChangeValue}
                        required
                    />

                </div>

                <div className="form-group">

                    <div className="clearfix">
                        <button
                            type="submit"
                            className="btn btn-success pull-right"
                            disabled={!this.state.value}
                        >
                            Update Display Name
                        </button>

                    </div>
                </div>

            </form>
        );
    }
}

class PasswordReset extends React.Component {

    onSubmit = e => {

        e.preventDefault();

        this.props.changeCover(true, () => {

            this.props.onSubmit(this.props.initialValue, () => {

                this.props.changeCover(false, this.props.afterSubmit);
            });
        });
    };

    render() {

        return (
            <form className={classNames({ hidden: this.props.hidden })} onSubmit={this.onSubmit}>

                <div className="form-group">

                    <label htmlFor="password-reset">Request Password Reset</label>

                    <input
                        type="text"
                        className="form-control"
                        id="password-reset"
                        value={`send to: ${this.props.initialValue}`}
                        readOnly={true}
                    />

                </div>

                <div className="form-group">

                    <div className="clearfix">

                        <button
                            type="submit"
                            className="btn btn-success pull-right"
                        >
                            Send Password Reset Email
                        </button>
                    </div>

                </div>


            </form>
        );
    }
}

class UpdateEmailAddress extends React.Component {

    state = {
        value: this.props.initialValue
    };

    onChangeValue = ({currentTarget: { value }}) => {

        this.setState({ value });
    };

    onSubmit = e => {

        e.preventDefault();

        this.props.changeCover(true, () => {

            this.props.onSubmit(this.state.value, () => {

                this.props.changeCover(false, this.props.afterSubmit);
            });
        });

    };

    render() {

        return (
            <form onSubmit={this.onSubmit}>

                <div className="form-group">

                    <label htmlFor="new-email">New Email Address</label>
                    <p className="text-muted">
                        Note: You will be logged out once your email has been updated. Also, for security, we will send a confirmation to your old email address once you update.
                    </p>
                    <input
                        type="email"
                        className="form-control"
                        id="new-email"
                        placeholder="mynewemail@example.com"
                        value={this.state.value}
                        onChange={this.onChangeValue}
                        required
                    />

                </div>

                <div className="form-group">

                    <div className="clearfix">
                        <button
                            type="submit"
                            className="btn btn-danger pull-right"
                            disabled={!this.state.value}
                        >
                            Update Email Address
                        </button>

                    </div>
                </div>


            </form>
        );
    }
}

function withKey(Component) {

    return class ComponentWithKey extends React.Component {

        state = {
            key: Math.random()
        };

        afterSubmit = () => {
            this.setState({ key: Math.random() });
        };

        render() {

            return (
                <Component {...this.props} afterSubmit={this.afterSubmit} key={this.state.key} />
            );
        }
    };
}

const DisplayNameHOC = withKey(DisplayName);
const PasswordResetHOC = withKey(PasswordReset);
const BillingInfoHOC = withKey(BillingInfo);
const UpdateEmailAddressHOC = withKey(UpdateEmailAddress);
const DeleteAccountHOC = withKey(DeleteEverything);

class Account extends React.Component {

    state = {
        dangerZoneIsShowing: false
    };

    onToggleDangerZone = e => {

        this.setState({ dangerZoneIsShowing: !this.state.dangerZoneIsShowing });
    };

    render() {

        return (
            <Modal className="account" show={this.props.show}>

                <Modal.Header closeButton onHide={this.props.hide}>
                </Modal.Header>

                <Modal.Body>


                    <div className="panel panel-default">

                        <div className="panel-body">

                            <fieldset>
                                <legend>
                                    User Info
                                </legend>

                                <div className="col-lg-10 col-lg-offset-1">

                                    <DisplayNameHOC
                                        initialValue={this.props.user.displayName}
                                        onSubmit={this.props.changeUserDisplayName}
                                        changeCover={this.props.changeCover}
                                    />

                                    {/*<PasswordResetHOC*/}
                                        {/*initialValue={this.props.user.email}*/}
                                        {/*onSubmit={this.props.requestPasswordReset}*/}
                                        {/*changeCover={this.props.changeCover}*/}
                                        {/*hidden={this.props.user.providerData[0].providerId === 'password'}*/}
                                    {/*/>*/}

                                </div>

                            </fieldset>

                        </div>
                    </div>

                    <div className="panel panel-default">

                        <div className="panel-body">

                            <fieldset>

                                <legend>
                                    Billing Info
                                </legend>

                                <div className="row">

                                    <div className="col-lg-12">

                                        {BillingInfo.description(this.props.stripeCustomer)}

                                    </div>

                                    <div className="col-lg-10 col-lg-offset-1">

                                        <BillingInfoHOC
                                            stripeCustomer={this.props.stripeCustomer}
                                            changeCover={this.props.changeCover}
                                            changeStripeCustomer={this.props.changeStripeCustomer}
                                            size="small"
                                        />

                                    </div>

                                </div>

                            </fieldset>

                        </div>
                    </div>


                    <div className={classNames('panel panel-default danger-zone', { collapsed: !this.state.dangerZoneIsShowing })}>

                        <div className="panel-body">

                            <fieldset>

                                <legend>
                                    <button type="button" onClick={this.onToggleDangerZone}>
                                        Delete Account <span className={`glyphicon glyphicon-${this.state.dangerZoneIsShowing ? 'minus' : 'plus'}`} />
                                    </button>
                                </legend>

                                <div className="row">

                                    <div className="col-lg-10 col-lg-offset-1">

                                        {/*<UpdateEmailAddressHOC*/}
                                            {/*initialValue={this.props.user.email}*/}
                                            {/*onSubmit={this.props.changeUserEmail}*/}
                                            {/*changeCover={this.props.changeCover}*/}
                                        {/*/>*/}

                                        <div className="body">
                                            <DeleteAccountHOC
                                                onSubmit={this.props.deleteAccount}
                                                changeCover={this.props.changeCover}
                                                label="Account Removal"
                                            >
                                                Warning: all your data (including projects, comments, etc.) will be deleted. This action is <strong>irreversible</strong>.
                                            </DeleteAccountHOC>
                                        </div>

                                    </div>

                                </div>


                            </fieldset>

                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        );
    }
}

export default Account;



// WEBPACK FOOTER //
// ./src/components/_global/Account.jsx